import httpClient from "@/api/httpClient";

export default {
  methods: {
    authLogin: async function(obj) {
      try {
        let response = await httpClient.post("admin/login", obj);
        return response;
      } catch (error) {
        throw error;
      }
    }
  }
};
